import OrderRentingDays from './OrderRentingDays'

export default OrderRentingDays
